export const TAGS_LIST_SUCCESS = "TAGS_LIST_SUCCESS";
export const TAGS_CREATE_SUCCESS = "TAGS_CREATE_SUCCESS";
export const TAGS_UPDATE_SUCCESS = "TAGS_UPDATE_SUCCESS";
export const TAGS_DELETE_SUCCESS = "TAGS_DELETE_SUCCESS";
export const SET_TAGS_SCOPE_FILTER = "SET_TAGS_SCOPE_FILTER";
export const SET_TAGS_SEARCH_TEXT = "SET_TAGS_SEARCH_TEXT";
export const SET_TAGS_VIEW_MODE = "SET_TAGS_VIEW_MODE";
